<template>
  <div class="delivery-info body-m-regular">
    <div class="pickup icons">
      {{ pickup }}
    </div>
    <div v-if="delivery.cost" class="delivery icons">
      Доставка {{ delivery.dayText
      }}<span :class="{ green: delivery.cost === 'бесплатно' }">{{
        delivery.cost
      }}</span>
    </div>
    <div v-if="payment" class="payment icons">{{ payment }}</div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import {
  getDeliveryDateRange,
  getFutureDay,
  getWeekDay,
} from '~/utils/dateUtils';

export default defineComponent({
  name: 'DeliveryInfo',
  props: {
    model: {
      type: Object,
      required: true,
    },
    isShowShop: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    // текст самовывоза
    const pickup = computed(() => {
      if (
        props.model?.pickup?.description ||
        props.model?.pickup?.options?.length
      )
        return `Самовывоз есть`;
      return `Самовывоз нет`;
    });

    // текст доставки
    const delivery = computed<{ cost: string; dayText: string }>(() => {
      if (!props.model.delivery) return { cost: '', dayText: '' };

      // через сколько дней минимально доставка
      const day: number | null =
        props.model.delivery.options && props.model.delivery.options.length > 0
          ? props.model.delivery.options.reduce(
              (day: number | null, item: { days: string | undefined }) => {
                if (item.days) {
                  const interval = item.days.split(/\D/).map((d) => Number(d));
                  if (
                    interval &&
                    interval.length &&
                    (day === null || interval[0] < day)
                  )
                    return interval[0];
                }
                return day;
              },
              null
            )
          : null;

      // рассчет минимальной доставки из delivery.options
      const getDeliveryOptionsCost = (arr: { cost: number | null }[]) => {
        if (arr?.length === 1 && arr[0].cost === null) return 'есть';
        const min = Math.min(...arr.map((item) => (item.cost ? item.cost : 0)));
        return min ? `от\u00A0${min}\u00A0₽` : min === 0 ? 'бесплатно' : 'есть';
      };

      const getCost = () => {
        if (
          props.model.delivery.cost === null &&
          (!props.model.delivery.options ||
            !props.model.delivery.options.length)
        ) {
          return 'есть';
        }

        if (!props.model.delivery.cost)
          return props.model.delivery.options &&
            props.model.delivery.options.length
            ? getDeliveryOptionsCost(props.model.delivery.options)
            : 'есть';

        return `${props.model.delivery.fixed ? '' : 'от\u00A0'}${
          props.model.delivery.cost
        }\u00A0₽`;
      };

      // цена доставки
      const cost: string = getCost();

      // текст доставки по дате
      let dayText = '';
      if (day !== null && day < 3) {
        dayText = `${getFutureDay(day)} - `;
      } else if (day !== null) {
        const date = new Date();
        date.setDate(date.getDate() + day);
        dayText = `в ${getWeekDay(date)}, ${getDeliveryDateRange(
          date.toDateString()
        ).toLowerCase()} - `;
      }

      return {
        dayText,
        cost,
      };
    });

    // Безнал
    const payment = computed(() => {
      if (
        props.model.shop_info?.accepts_card &&
        props.model.shop_info?.accepts_cash
      )
        return 'Оплата картой и наличными';
      if (props.model.shop_info?.accepts_card) return 'Оплата картой';
      if (props.model.shop_info?.accepts_cash) return 'Оплата наличными';
      const payment = props.model.shop_info?.payment_options || '';
      return !payment || payment === 'нет' ? 'Оплата наличными' : '';
    });

    // Магазин
    const shop = computed(() => {
      return props.model.shop_info?.name || '';
    });

    return { pickup, delivery, payment, shop };
  },
});
</script>
<style scoped lang="scss" src="./DeliveryInfoScss.scss"></style>
